export enum EMediaType {
  Layout = 'layout',
  CianLayout = 'cianLayout',
  Photo = 'photo',
  Video = 'video',
  Component = 'component',
  Tour = 'Tour',
  FloorPlan = 'FloorPlan',
}

interface IMedia<T extends EMediaType> {
  type: T;
  src: string;
}

interface IMediaWithThumbnail extends IMedia<EMediaType.CianLayout | EMediaType.Layout | EMediaType.Photo> {
  thumbnailSrc: string;
}

interface IMediaComponent {
  type: EMediaType.Component | EMediaType.Tour | EMediaType.FloorPlan;
  component: React.ReactNode;
  thumbnailSrc: string;
}

export type TMedia = IMedia<EMediaType.Video> | IMediaWithThumbnail | IMediaComponent;
